/*export { Sprite as Shape } from './Sprite';*/
import { __extends } from "tslib";
import { constructClassFromSymbol } from '@awayfl/avm2';
import { DisplayObject } from './DisplayObject';
import { Sprite as AwaySprite } from '@awayjs/scene';
/**
 * This class is used to create lightweight shapes using the ActionScript drawing application program interface (API).
 * The Shape class includes a <codeph class="+ topic/ph pr-d/codeph ">graphics</codeph> property,
 * which lets you access methods from the Graphics class.
 *
 *   <p class="- topic/p ">The Sprite class also includes a
 * <codeph class="+ topic/ph pr-d/codeph ">graphics</codeph>property,
 * and it includes other features not available to the
 * Shape class. For example, a Sprite object is a display object container,
 * whereas a Shape object is not (and cannot contain
 * child display objects). For this reason, Shape objects consume less memory than Sprite objects that contain the
 * same graphics. However, a Sprite object supports user input events, while a Shape object does not.</p>
 */
var Shape = /** @class */ (function (_super) {
    __extends(Shape, _super);
    /**
         * Creates a new Shape object.
         */
    function Shape() {
        var _this = _super.call(this) || this;
        _this._graphics = new _this.sec.flash.display.Graphics(_this._adaptee.graphics);
        return _this;
    }
    Shape.prototype.createAdaptee = function () {
        var newAdaptee = AwaySprite.getNewSprite();
        //console.log("createAdaptee AwaySprite");
        newAdaptee.reset();
        //FrameScriptManager.execute_queue();
        return newAdaptee;
    };
    Object.defineProperty(Shape.prototype, "graphics", {
        /**
             * Specifies the Graphics object belonging to this Shape object, where vector
             * drawing commands can occur.
             */
        get: function () {
            return this._graphics;
        },
        enumerable: true,
        configurable: true
    });
    Shape.prototype.clone = function () {
        if (!this._symbol) {
            throw ('_symbol not defined when cloning movieclip');
        }
        var clone = constructClassFromSymbol(this._symbol, this._symbol.symbolClass);
        var adaptee = new AwaySprite();
        this.adaptee.copyTo(adaptee);
        clone.adaptee = adaptee;
        clone._stage = this.activeStage;
        clone.adaptee.graphics = this.graphics;
        return clone;
    };
    return Shape;
}(DisplayObject));
export { Shape };
